module.exports = {
	providerLimit: 99999999,
};
